import React, { useState } from 'react';
import { Shield } from 'lucide-react';
import { CALENDAR_LINK } from './Header';
import { LegalModal, LegalDoc } from './LegalModal';
export function Footer() {
  const [legalDoc, setLegalDoc] = useState<LegalDoc | null>(null);
  return <footer className="bg-brand-navy pt-16 pb-8 border-t border-white/10" data-id="element-34">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-35">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-36">
          <div className="md:col-span-2" data-id="element-37">
            <div className="flex items-center gap-2 mb-4" data-id="element-38">
              <Shield className="w-8 h-8 text-brand-green" data-id="element-39" />
              <span className="font-bold text-xl tracking-tight text-white" data-id="element-40">
                Protection & Savings
              </span>
            </div>
            <p className="text-gray-400 max-w-md mb-6 leading-relaxed" data-id="element-41">
              Ayudamos a las familias a salir de la carrera de las ratas y tomar
              control de su futuro financiero. Construimos, juntos, un legado
              generacional con estrategias inteligentes que protegen lo que más
              importa.
            </p>
            <a href={CALENDAR_LINK} target="_blank" rel="noopener noreferrer" className="inline-block bg-brand-green hover:bg-green-700 text-white px-6 py-2 rounded-md font-semibold transition-colors" data-id="element-42">
              Habla con un experto
            </a>
          </div>

          <div data-id="element-43">
            <h4 className="text-white font-semibold mb-4" data-id="element-44">Enlaces Rápidos</h4>
            <ul className="space-y-2" data-id="element-45">
              <li data-id="element-46">
                <a href="#beneficios" className="text-gray-400 hover:text-white transition-colors" data-id="element-47">
                  Beneficios del IUL
                </a>
              </li>
              <li data-id="element-48">
                <a href="#como-funciona" className="text-gray-400 hover:text-white transition-colors" data-id="element-49">
                  Cómo Funciona
                </a>
              </li>
              <li data-id="element-50">
                <a href="#faq" className="text-gray-400 hover:text-white transition-colors" data-id="element-51">
                  Preguntas Frecuentes
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-52">
            <h4 className="text-white font-semibold mb-4" data-id="element-53">Contacto</h4>
            <ul className="space-y-2 text-gray-400" data-id="element-54">
              <li data-id="element-55">info@protectionandsavings.com</li>
              <li data-id="element-56">Atención en todo EE.UU.</li>
              <li className="pt-2" data-id="element-57">
                <span className="text-xs text-gray-500" data-id="element-58">
                  Agentes licenciados en seguros de vida.
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-59">
          <p className="text-gray-500 text-sm text-center md:text-left" data-id="element-60">
            &copy; {new Date().getFullYear()} Protection & Savings. Todos los
            derechos reservados.
          </p>
          <div className="flex gap-4 text-sm text-gray-500" data-id="element-61">
            <button type="button" onClick={() => setLegalDoc('privacy')} className="hover:text-white transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-green rounded" data-id="element-62">
              Privacidad
            </button>
            <button type="button" onClick={() => setLegalDoc('terms')} className="hover:text-white transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-green rounded" data-id="element-63">
              Términos
            </button>
          </div>
        </div>

        <div className="mt-8 text-xs text-gray-600 text-center max-w-4xl mx-auto" data-id="element-64">
          <p data-id="element-65">
            Descargo de responsabilidad: La información proporcionada en este
            sitio web es solo para fines educativos e informativos y no
            constituye asesoramiento financiero, legal o fiscal. Las pólizas de
            Seguro de Vida Universal Indexado (IUL) están sujetas a los términos
            y condiciones de la compañía de seguros emisora. Los resultados
            pueden variar según la edad, salud y aportaciones del asegurado.
          </p>
        </div>
      </div>

      <LegalModal doc={legalDoc} onClose={() => setLegalDoc(null)} data-id="element-66" />
    </footer>;
}